import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchProductPurchasesArgs,
  FetchProductsArgs,
  FetchSalesArgs,
} from '../api/types/desk.types';

import {
  fetchProductPurchases,
  fetchProducts,
  fetchSales,
} from '../api/desk.api';

export const deskQueryKeys = createQueryKeys('desk', {
  fetchProducts: (args: FetchProductsArgs) => ({
    queryFn: () => fetchProducts(args),
    queryKey: [args.organizationId, args],
  }),
  fetchProductPurchases: (args: FetchProductPurchasesArgs) => ({
    queryFn: () => fetchProductPurchases(args),
    queryKey: [args.organizationId, args],
  }),
  fetchSales: (args: FetchSalesArgs) => ({
    queryFn: () => fetchSales(args),
    queryKey: [args.organizationId, args],
  }),
});
